/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

interface Props {
  children: React.ReactChild | React.ReactChild[];
  scale?: number;
  style?: any; //css in js
}

export const SpinnerWrapper = ({ children, scale, style }: Props) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        ...style,
      }}
    >
      <div
        style={{
          // Scaling doesn't seems to work well with vectors in safari
          transform: scale ? `scale(${scale})` : "",
        }}
      >
        {children}
      </div>
    </div>
  );
};
